// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"q8-z","button":"r8-z","disabled":"s8-z","creditCard":"t8-z","wrapper":"u8-z"};